import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon, MapPinIcon, PhoneIcon, MailIcon, ClockIcon, ShoppingBagIcon, FacebookIcon, InstagramIcon, MusicIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ContactPage() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="pt-[64px] md:pt-[72px]" data-id="element-462">
      {/* SECȚIUNEA 1 — TITLU ȘI INVITAȚIE */}
      <section className="bg-brand-beige section-padding" data-id="element-463">
        <div className="container-custom" data-id="element-464">
          <div className="max-w-3xl mx-auto text-center" data-id="element-465">
            <h1 className="font-playfair text-[40px] md:text-[56px] font-bold text-brand-navy mb-6" data-id="element-466">
              CONTACT
            </h1>
            <p className="font-source text-[18px] text-brand-textSecondary" data-id="element-467">
              Te pot ghida mai departe, simplu și direct. Dacă ai o întrebare
              despre dezvoltarea copilului tău, vrei detalii despre Programul
              CRESC sau vrei să programezi o evaluare online, mai jos ai toate
              canalele prin care mă poți contacta.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-brand-ivory section-padding" data-id="element-468">
        <div className="container-custom" data-id="element-469">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-470">
            {/* SECȚIUNEA 2 — SESIUNE CADOU (CTA PRINCIPAL) */}
            <div className="bg-white p-8 rounded-[24px] shadow-card border-t-4 border-brand-coral" data-id="element-471">
              <h2 className="font-playfair text-[28px] font-bold text-brand-navy mb-6" data-id="element-472">
                Vrei o evaluare online a copilului tău?
              </h2>
              <p className="font-source text-[16px] text-brand-text mb-6" data-id="element-473">
                Cel mai rapid mod este să mă contactezi direct pe WhatsApp. În
                mesaj, te rog să incluzi:
              </p>
              <ul className="space-y-4 mb-8" data-id="element-474">
                <li className="flex items-start gap-3" data-id="element-475">
                  <div className="w-6 h-6 rounded-full bg-brand-gold/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-476">
                    <span className="w-2 h-2 rounded-full bg-brand-gold" data-id="element-477"></span>
                  </div>
                  <span className="font-source text-[16px] text-brand-text" data-id="element-478">
                    Numele tău și vârsta copilului
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-479">
                  <div className="w-6 h-6 rounded-full bg-brand-gold/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-480">
                    <span className="w-2 h-2 rounded-full bg-brand-gold" data-id="element-481"></span>
                  </div>
                  <span className="font-source text-[16px] text-brand-text" data-id="element-482">
                    O propoziție scurtă despre ce te îngrijorează (nu vorbește,
                    vorbește puțin, are întârzieri, a primit un diagnostic)
                  </span>
                </li>
              </ul>
              <div className="flex flex-col gap-3" data-id="element-483">
                <a href="https://wa.me/40723580805" target="_blank" rel="noopener noreferrer" className="btn-primary flex items-center justify-center gap-2" data-id="element-484">
                  <MessageCircleIcon size={20} data-id="element-485" />
                  Scrie-mi pe WhatsApp
                </a>
                <p className="font-source text-[13px] text-brand-textSecondary text-center" data-id="element-486">
                  Apăsând pe buton se va deschide aplicația WhatsApp cu un mesaj
                  pregătit.
                </p>
              </div>
            </div>

            {/* SECȚIUNEA 3 — DATE DE CONTACT */}
            <div className="space-y-8" data-id="element-487">
              <div data-id="element-488">
                <h2 className="font-playfair text-[32px] font-bold text-brand-navy mb-2" data-id="element-489">
                  Cristina Geană
                </h2>
                <p className="font-montserrat font-medium text-[14px] text-brand-textSecondary uppercase tracking-wide" data-id="element-490">
                  Psiholog Clinician . Dezvoltarea și Terapia Copilului Mic .
                  Programul CRESC
                </p>
              </div>

              <div className="space-y-6" data-id="element-491">
                <div className="flex items-start gap-4" data-id="element-492">
                  <div className="w-12 h-12 rounded-full bg-brand-beige flex items-center justify-center flex-shrink-0 text-brand-coral" data-id="element-493">
                    <PhoneIcon size={24} data-id="element-494" />
                  </div>
                  <div data-id="element-495">
                    <h3 className="font-montserrat font-bold text-[16px] text-brand-navy mb-1" data-id="element-496">
                      Telefon
                    </h3>
                    <a href="tel:+40723580805" className="font-source text-brand-textSecondary hover:text-brand-coral transition-colors" data-id="element-497">
                      +40723580805
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-498">
                  <div className="w-12 h-12 rounded-full bg-brand-beige flex items-center justify-center flex-shrink-0 text-brand-coral" data-id="element-499">
                    <MailIcon size={24} data-id="element-500" />
                  </div>
                  <div data-id="element-501">
                    <h3 className="font-montserrat font-bold text-[16px] text-brand-navy mb-1" data-id="element-502">
                      Email
                    </h3>
                    <a href="mailto:psiholog.ploiesti@yahoo.com" className="font-source text-brand-textSecondary hover:text-brand-coral transition-colors" data-id="element-503">
                      psiholog.ploiesti@yahoo.com
                    </a>
                  </div>
                </div>
              </div>

              <div className="pt-6 border-t border-gray-200" data-id="element-504">
                <h3 className="font-montserrat font-bold text-[16px] text-brand-navy mb-4" data-id="element-505">
                  Social Media
                </h3>
                <div className="flex flex-col sm:flex-row flex-wrap gap-4" data-id="element-506">
                  <a href="https://www.facebook.com/profile.php?id=100001552001084" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 px-6 py-3 bg-[#1877F2] text-white rounded-[12px] hover:bg-[#1877F2]/90 transition-colors font-montserrat text-[14px] font-bold shadow-md" data-id="element-507">
                    <FacebookIcon size={18} data-id="element-508" /> Facebook
                  </a>
                  <a href="https://www.instagram.com/cristina.geana/" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#F56040] text-white rounded-[12px] hover:opacity-90 transition-opacity font-montserrat text-[14px] font-bold shadow-md" data-id="element-509">
                    <InstagramIcon size={18} data-id="element-510" /> Instagram
                  </a>
                  <a href="https://www.tiktok.com/@cristinageanapsi" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 px-6 py-3 bg-black text-white rounded-[12px] hover:bg-black/90 transition-colors font-montserrat text-[14px] font-bold shadow-md" data-id="element-511">
                    <MusicIcon size={18} data-id="element-512" /> TikTok
                  </a>
                  <a href="https://wa.me/40723580805" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 px-6 py-3 bg-[#25D366] text-white rounded-[12px] hover:bg-[#25D366]/90 transition-colors font-montserrat text-[14px] font-bold shadow-md" data-id="element-513">
                    <MessageCircleIcon size={18} data-id="element-514" /> WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </motion.div>;
}